import { render, staticRenderFns } from "./SIMFile.vue?vue&type=template&id=a6ec69bc&scoped=true&"
import script from "./SIMFile.vue?vue&type=script&lang=js&"
export * from "./SIMFile.vue?vue&type=script&lang=js&"
import style0 from "./SIMFile.vue?vue&type=style&index=0&id=a6ec69bc&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6ec69bc",
  null
  
)

export default component.exports